import axios from 'axios';
import { dropIn } from './adyen';

import { DELIVERY, STORAGE, EXPORTCONSOL } from './delivery_types';

function startBasketAnimation() {
    $(".basket_page").addClass("loading");
}

function finishBasketAnimation() {
    $(".basket_page").removeClass("loading");
}

function clearAlerts() {
    $('.basket_container > .alert:not(.important)').remove();
}

export default function () {

    if ($('.shipping-method-tabs').length) {

        startBasketAnimation();

        let tab = $('.shipping-method-tabs button.active').attr('id');

        let data = {
            "slAccountCode": $('select[name="slAccountCode"]').val()
        };

        switch (tab) {
            case 'delivery-tab':
                data['shippingType'] = DELIVERY;
                data['deliveryAddressId'] = $('input[name="deliveryAddressId"]:checked').val();
                data['deliveryInstruction'] = $('textarea[name="deliveryInstructionsInput"]').val();

                $('.additionalDeliveryOption').each((index, element) => {
                    if ($(element).hasClass('active')) {
                        data['shippingType'] = $(element).find('input:checked').val();
                    }
                });
                
                break;
            case 'inbond-tab':
                data['shippingType'] = STORAGE;
                data['storageLocationId'] = $('input[name="storageLocationId"]').val();

                $('.additionalStorageOption').each((index, element) => {
                    if ($(element).hasClass('active')) {
                        data['shippingType'] = $(element).find('input:checked').val();
                    }
                });

                break;
            case 'exportconsol-tab':
                data['shippingType'] = EXPORTCONSOL;
                data['exportConsolDeliveryInstruction'] = $('.shipping-method-tabs button.active').attr('data-instruction');
                break;
        }

        $(".payment__wrapper .payment__method").empty();

        axios({
            method: 'post',
            url: "/my-basket/ajax/checkout-post",
            data: data
        })
            .then(function (response) {
                const $paymentWrapper = $(".payment__wrapper");
                const { adyenComponent } = response.data.data;
                
                clearAlerts();

                $paymentWrapper.find(".payment__method").empty().append(adyenComponent);
                $paymentWrapper.show();

                dropIn((reference) => {
                    window.location.href = "/payment/checkout-result?ref=" + reference;
                },
                (errCode = null) => {
                    axios.request({
                        url: '/payment/fail-form-checkout',
                        method: 'get',
                        headers: { 'X-Requested-With': 'XMLHttpRequest' },
                        params: errCode ? { errCode: errCode } : {}
                    }).then(function (response) {
                        $(
                            ".adyen-checkout__status__text"
                        ).append(response.data);
                        $('.paylater__form').removeClass('d-none');
                        $('.paylater__form button').removeClass('inverted');
                    });
                });
                
            }).catch(() => {
                $(".payment__wrapper").hide();
             }).finally(() => {
                axios.get('/my-basket/ajax/get-checkout-error').then(function (response) {
                    clearAlerts();
                    $('.basket_container').prepend($(response.data.html));

                    finishBasketAnimation();
                });
            });
    }

}